import { SessionStorage } from "./sessionStorage";

class UserAuthDataStorage extends SessionStorage {
	public constructor() {
		super({
			storageKey: "user_data",
		});
	}
}

export const userAuthDataStorage = new UserAuthDataStorage();
